import HttpRequest from '@/libs/axios'
import config from '@/config'
const baseUrl = config.baseUrl[process.env.NODE_ENV] ? config.baseUrl[process.env.NODE_ENV] : undefined

const axios = new HttpRequest(baseUrl)
export default axios
